<template>
	<div class="ticket-thread flex-1 px-4 py-5 sm:px-6 lg:px-8">
		<!-- Reading column: centered by default, full width when the thread has the space !-->
		<div class="mx-auto w-full" :class="wide ? 'max-w-none' : 'max-w-2xl'">
			<!-- Um bloco por dia !-->
			<template v-for="day in days">
				<!-- mt-6 first:mt-0: spaces the days apart without pushing the first one down !-->
				<div :key="day.key" class="mt-6 first:mt-0">
					<!-- Dia !-->
					<div class="relative mb-3 flex items-center justify-center">
						<span class="absolute inset-x-0 top-1/2 h-px bg-gray-200" aria-hidden="true"></span>
						<span class="relative rounded-full bg-white px-3 py-1 text-[11px] font-semibold uppercase tracking-wide text-gray-500 ring-1 ring-gray-200">
							{{ day.label }}
						</span>
					</div>
					<!-- Mensagens do dia !-->
					<ul role="list" class="space-y-3">
						<template v-for="message in day.messages">
							<SupportTicketMessage :key="message.id" :message="message" :requester-id="requesterId"/>
						</template>
					</ul>
				</div>
			</template>
			<!-- Sem mensagens !-->
			<template v-if="!days.length">
				<p class="rounded-lg bg-white py-10 text-center text-sm text-gray-500 ring-1 ring-gray-200">
					Este ticket ainda não tem mensagens.
				</p>
			</template>
			<!-- Resposta !-->
			<slot name="composer"/>
		</div>
	</div>
</template>

<script>
import SupportTicketMessage from "./SupportTicketMessage.vue"

export default {
	name: "SupportTicketThread",
	components: {SupportTicketMessage},
	props: {
		messages: {
			type: Array,
			default: () => []
		},
		/**
		 * Id de quem abriu o chamado: o cliente, que fica à esquerda
		 */
		requesterId: [Number, String],
		/**
		 * Full width thread, for places where the conversation already sits in a narrow column
		 */
		wide: Boolean
	},
	computed: {
		/**
		 * Mensagens agrupadas por dia
		 * @returns {Array<{key: string, label: string, messages: Array}>}
		 */
		days() {
			const days = []

			for (const message of this.messages ?? []) {
				const date = this.$dayjs(message.created_at)
				const key = date.isValid() ? date.format("YYYY-MM-DD") : "—"
				const day = days[days.length - 1]

				if (day?.key === key) {
					day.messages.push(message)
					continue
				}

				days.push({key, label: this.dayLabel(date), messages: [message]})
			}

			return days
		}
	},
	methods: {
		/**
		 * Rótulo do dia: Hoje, Ontem ou a data por extenso
		 * @param date
		 * @returns {string}
		 */
		dayLabel(date) {
			if (!date.isValid()) return "Sem data"

			const today = this.$dayjs()

			if (date.isSame(today, "day")) return "Hoje"
			if (date.isSame(today.subtract(1, "day"), "day")) return "Ontem"

			return date.format("D [de] MMMM [de] YYYY")
		}
	}
}
</script>

<style scoped>
.ticket-thread {
	background-color: #EDF0F3;
}
</style>
